export default {
  header: {
    padding: '1.25rem 0 0 0',
  },
};
